var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.079,
    height: 14.079,
    viewBox: "0 0 14.079 14.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fbf8fd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-icon",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linha_54",
    "data-name": "Linha 54",
    className: "cls-1",
    d: "M12.079,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H12.079a1,1,0,0,1,1,1A1,1,0,0,1,12.079,1Z",
    transform: "translate(0 6.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linha_55",
    "data-name": "Linha 55",
    className: "cls-1",
    d: "M12.079,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H12.079a1,1,0,0,1,1,1A1,1,0,0,1,12.079,1Z",
    transform: "translate(6.04) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.c979bb995e9b67c59cbf3841f35e75e3.svg";
export { ForwardRef as ReactComponent };